"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const Close_1 = __importDefault(require("@material-ui/icons/Close"));
const BotaoFechar = ({ onClose }) => {
    return (react_1.default.createElement(core_1.Grid, { container: true },
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, style: { textAlign: 'right' } },
            react_1.default.createElement(core_1.Tooltip, { title: "Fechar", placement: "top-end" },
                react_1.default.createElement(core_1.IconButton, { edge: "start", color: "inherit", onClick: onClose },
                    react_1.default.createElement(Close_1.default, null))))));
};
exports.default = BotaoFechar;
//# sourceMappingURL=index.js.map